import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Col, Container, Row, Spinner } from "reactstrap";
import jsk from "../../../../src/assets/images/jsk.png";
import { FaCheckCircle, FaUserCircle } from "react-icons/fa";
import AnnonceItem from "pages/Annonces/components/AnnonceItem";
import { useAgent } from "hooks/useAgent";
import { useTranslation } from "react-i18next";
import { getProfile } from "store/slices/agentSlice";
import EditAgentProfile from "./EditAgentProfile";
import AgentInfo from "./AgentInfo";
import { useSearchParams } from "react-router-dom";
import AnnonceListComponent from "pages/Annonces/AgenAnnonceList/AnnonceListComponent";

const AgentProfile = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [mode, setMode] = useState("view");
  const [visibleCompanant, setVisibleCompanant] = useState("profile");
  const { agent, loading, error } = useSelector((state) => state.Agent);

  const { activeSinceMonth, activeSinceYear } = useMemo(() => {
    if (!agent?.createdAt) {
      return { activeSinceMonth: null, activeSinceYear: null };
    }
    const date = new Date(agent.createdAt);
    return {
      activeSinceMonth: date.toLocaleString("default", { month: "long" }),
      activeSinceYear: date.getFullYear(),
    };
  }, [agent]);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    setVisibleCompanant(tab ? tab : "profile");
  }, [tab])

  // const annonces = [
  //   {
  //     id: 1,
  //     title: "Recrutement gardien de but",
  //     status: "Validée",
  //     datePublication: "2025-01-02",
  //     nombreVue: null,
  //   },
  //   {
  //     id: 2,
  //     title: "Recrutement gardien de but",
  //     status: "Validée",
  //     datePublication: "2025-01-02",
  //     nombreVue: null,
  //   },

  //   {
  //     id: 3,
  //     title: "Recrutement gardien de but",
  //     status: "Validée",
  //     datePublication: "2025-01-02",
  //     nombreVue: 125,
  //   },
  // ];

  if (loading) return <Spinner />;
  if (error) return <Alert color="danger">{error.message}</Alert>;

  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-title-box">
          <Row>
            <Row
              className="d-flex justify-content-center "
              style={{ backgroundColor: "#F3F8F9" }}
            >
              <Col
                md="8"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="d-flex align-items-center mb-4 "
                  style={{ width: "50%" }}
                >
                  <div className="me-3">
                    <FaUserCircle size={64} className="text-secondary" />
                  </div>
                  <div>
                    <h5
                      className="mb-1"
                      style={{ font: "Visby CF", color: "#000000" }}
                    >
                      {agent?.firstName + " " + agent?.lastName}
                    </h5>
                    <p className="text-muted mb-2">
                      {t("dashboard.activeSince")} : {activeSinceMonth}{" "}
                      {activeSinceYear}
                    </p>
                    <Button
                      style={{
                        backgroundColor: "#157088B2",
                        color: "#ffffff",
                        font: "Visby CF",
                        borderRadius: 5,
                      }}
                      className="btn btn-primary btn-sm"
                      onClick={() => { setMode("edit"); setVisibleCompanant("profile"); }}
                    >
                      {t("profile.editProfile")}
                    </Button>
                  </div>
                </div>
                <div style={{ width: "30%" }}>
                  <p
                    style={{ font: "Visby CF", color: "#000000", fontSize: 15 }}
                  >
                    {t("profile.verifieAccountRequest")}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "center",
                      marginBottom: 20,
                    }}
                  >
                    <a
                      href="/"
                      className="text-primary"
                      style={{
                        color: "#157088",
                        textDecoration: "underline",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {t("profile.verifieAccount")}
                    </a>
                    <FaCheckCircle style={{ marginLeft: "8px" }} />
                  </div>
                </div>
              </Col>
            </Row>

            <div
              style={{
                marginTop: 10,
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                justifyContent: "flex-start",
                paddingLeft: "30px",
              }}
            >
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "profile" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("profile")}
              >
                {t("profile.profile")}
              </Button>
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "mesAnnonces" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("mesAnnonces")}
              >
                {t("profile.myAds")}
              </Button>
              {/* <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "réglages" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("réglages")}
              >
                {t("profile.settings")}
              </Button> */}
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "notifications" && {
                    opacity: "50%",
                  }),
                }}
                onClick={() => setVisibleCompanant("notifications")}
              >
                {t("profile.notification")}
              </Button>
            </div>
            <hr
              style={{
                marginTop: "10px",
                borderColor: "EAEAEA",
                borderWidth: "2px",
                marginBottom: 50,
              }}
            />

            {mode === "view" && visibleCompanant === "profile" && <AgentInfo />}
            {mode === "edit" && visibleCompanant === "profile" && (
              <EditAgentProfile onCancel={() => setMode("view")} />
            )}
            {visibleCompanant === "mesAnnonces" &&
              // annonces.map((annonce, key) => (
              //   <AnnonceItem annonce={annonce} key={key}></AnnonceItem>
              // ))
              <AnnonceListComponent />
            }
            {visibleCompanant === "notifications" &&
              <h3>Aucune notification trouvée</h3>
            }
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default AgentProfile;
